// Zone ads texts: imbalance report, drafts and templates. Registered with the
// other vocabularies in AppComponent.
export const locale = {
  lang: 'en',
  data: {
    ZONE_ADS: {
      ZONE: 'Zone',
      TARGET_ROLE: 'Aimed at',
      STATUS_LABEL: 'Status',
      BUDGET: 'Budget',
      BUDGET_EUROS: 'Budget (€)',
      DURATION: 'Duration',
      DURATION_DAYS: 'Duration (days)',
      DAYS: '{{count}} d',
      RADIUS_KM: 'Radius (km)',
      ADVANTAGE: 'Meta Advantage+ audience',
      ADVANTAGE_HINT: 'Meta may broaden age and interests to improve performance; the zone is still a limit.',
      ROUTINES: 'Routines',
      CREATED_AT: 'Created',
      UPDATED_AT: 'Updated',
      ACTIONS: 'Actions',
      OPEN: 'Open',
      OPEN_MAPS: 'View on Google Maps',
      NO_ZONE_LABEL: 'No zone name',
      FILTER_ALL_STATUSES: 'All statuses',
      FILTER_ALL_ROLES: 'All audiences',
      CLEAR_FILTERS: 'Clear filters',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      RETRY: 'Retry',
      RELOAD: 'Reload',
      LOADING: 'Loading…',
      SHOW: 'Show',
      HIDE: 'Hide',
      ACCEPT: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      SAVING: 'Saving…',
      SAVE_CHANGES: 'Save changes',
      REVIEW_FIELDS: 'Check the highlighted fields.',
      ERROR_FORBIDDEN_ACTION: 'You are not allowed to do this.',

      ROLE: {
        driver: 'Drivers',
        rider: 'Riders',
        both: 'Drivers and riders',
      },
      STATUS: {
        draft: 'Draft',
        approved: 'Approved',
        publishing: 'Publishing',
        publish_failed: 'Publishing failed',
        published: 'Published',
        finished: 'Finished',
        rejected: 'Rejected',
        meta_rejected: 'Rejected by Meta',
      },

      VALIDATION: {
        REQUIRED: 'This field is required.',
        INTEGER: 'It must be a whole number.',
        RANGE: 'It must be between {{min}} and {{max}}.',
        EURO_CENTS: 'Use two decimals at most.',
        MIN_BUDGET: 'The minimum budget is {{min}}.',
        HTTPS_URL: 'It must be an https:// address.',
        MAX_LENGTH: '{{max}} characters at most.',
      },

      ERRORS: {
        zone_occupied: 'This zone already has an open draft for that audience.',
        already_decided: 'The draft is no longer awaiting a decision: it is now “{{status}}”.',
        not_editable: 'The draft can no longer be edited: it is now “{{status}}”.',
        not_publishable: 'The draft cannot be published: it is now “{{status}}”.',
        incomplete_draft: 'The draft is missing data required for approval.',
        meta_not_configured: 'Publishing to Meta is not configured.',
        template_in_use: 'A draft uses this template.',
        not_found: 'The draft no longer exists.',
        draft_in_meta: 'This draft reached Meta: it cannot be deleted, only deactivated with “Reject”.',
      },
      APPROVE_MISSING: {
        template_id: 'An active template for the same audience as the draft',
        zone_label: 'The zone name',
      },
      META_MISSING: {
        SERVICES_META_API_VERSION: 'Meta API version (server configuration)',
        SERVICES_META_AD_ACCOUNT_ID: 'Meta ad account (server configuration)',
        SERVICES_META_PAGE_ID: 'Facebook page (server configuration)',
        SERVICES_META_INSTAGRAM_USER_ID: 'Instagram account (server configuration)',
        SERVICES_META_ACCESS_TOKEN: 'Meta access token (server configuration)',
        SERVICES_META_APP_SECRET: 'Meta app secret (server configuration)',
        EFFECTS_META: 'Calls to Meta are turned off in this environment',
        ZONE_AD_SETTINGS_DSA_PAYOR: 'Who pays for the ad (DSA), in Settings',
        ZONE_AD_SETTINGS_DSA_BENEFICIARY: 'Who benefits from the ad (DSA), in Settings',
      },

      IMBALANCE: {
        TITLE: 'Cells with more drivers than riders or the other way round',
        SUB: 'Current routines per H3 cell: each user counts in the cell of their origin and of their destination.',
        RESOLUTION: 'H3 resolution',
        RESOLUTION_OPTION: 'Resolution {{resolution}}',
        MIN_USERS: 'Min. users',
        MIN_USERS_INVALID: 'Enter a whole number from 1.',
        SORT_LABEL: 'Order',
        SORT: {
          ratio_desc: 'Most drivers per rider',
          ratio_asc: 'Most riders per driver',
          drivers_desc: 'Most drivers',
          riders_desc: 'Most riders',
        },
        LIMIT: 'Cells',
        LIMIT_OPTION: '{{count}} cells',
        SEE_DRAFTS: 'View drafts',
        DRIVERS: 'Drivers',
        RIDERS: 'Riders',
        TOTAL_SEATS: 'Seats',
        AVERAGE_SEATS: 'Seats per driver',
        RATIO: 'Ratio',
        RATIO_HINT: 'Drivers ÷ (riders + 1)',
        SEATS_RATIO: 'Seat ratio',
        SEATS_RATIO_HINT: 'Seats ÷ (riders + 1)',
        LACKING_ROLE: 'Lacking',
        LACKING: {
          driver: 'Drivers needed',
          rider: 'Riders needed',
          none: 'Balanced',
        },
        NO_LOCALITY: 'No locality',
        LOAD_ERROR: 'The imbalance report could not be loaded.',
        EMPTY: 'No cell reaches the minimum number of users.',
        SHOWING: 'Showing {{shown}} of {{total}} cells',
        MAP_TOOLTIP: '{{drivers}} drivers · {{riders}} riders',
        ZOOM_IN: 'Zoom in',
        ZOOM_OUT: 'Zoom out',
        CREATE_DRAFT: 'Create draft',
        CREATE_TITLE: 'Create ad draft',
        ROLE_SUGGESTED: 'According to the report: {{lacking}}.',
        OPTIONAL_TITLE: 'Ad values',
        OPTIONAL_HINT: 'Optional: whatever you leave empty is taken from the zone ad settings.',
        FROM_SETTINGS: 'From settings',
        ADVANTAGE_ON: 'On',
        ADVANTAGE_OFF: 'Off',
        CREATE_SUBMIT: 'Create draft',
        CREATING: 'Creating…',
        CREATE_ERROR: 'The draft could not be created.',
        OPEN_OCCUPIED: 'View the open draft',
      },

      DRAFTS: {
        LIST_TITLE: 'Ad drafts',
        LIST_SUB: 'Generated by the system or created from the report. Open them to review, approve and publish.',
        FROM_REPORT: 'Imbalance report',
        LOAD_ERROR: 'The drafts could not be loaded.',
        EMPTY: 'There are no drafts yet.',
        EMPTY_FILTERED: 'No draft matches the filters.',
        SHOWING: 'Showing {{shown}} of {{total}} drafts',
        PER_PAGE: '{{count}} per page',
        PER_PAGE_LABEL: 'Drafts per page',
      },

      DETAIL: {
        TITLE: 'Ad draft',
        BACK: 'Back to the list',
        LOAD_NOT_FOUND: 'This draft does not exist.',
        LOAD_FORBIDDEN: 'You are not allowed to view this draft.',
        LOAD_FAILED: 'The draft could not be loaded.',
        RESOLUTION: 'Resolution {{resolution}}',
        APPROVED_AT: 'Approved',
        PUBLISHED_AT: 'Published',
        CLOSED_AT: 'Closed',
        ESTIMATED_SIGNUPS: 'Estimated sign-ups',
        DECIDED_BY: 'Decided by',
        REJECTED_REASON: 'Rejection reason',

        PUBLISHING_TITLE: 'Publishing to Meta',
        PUBLISHING_TEXT: 'The campaign is being created in the background. Reload in a moment to see the result.',
        PUBLISH_ERROR_TITLE: 'The last publication failed',

        READ_ONLY_TITLE: 'It can only be edited as a draft',
        READ_ONLY_TEXT: 'Once approved, the ad no longer changes: what you see is what gets published.',
        AD_TITLE: 'Ad',
        AD_SUB: 'The template sets the image and texts; the zone name replaces its placeholder.',
        TEMPLATE: 'Template',
        TEMPLATE_HINT: 'Active templates for {{role}}.',
        TEMPLATE_INACTIVE: '{{name}} (inactive)',
        TEMPLATE_OTHER: 'Current template (not in the list)',
        TEMPLATES_ERROR: 'The templates could not be loaded.',
        ZONE_LABEL: 'Zone name',
        ZONE_LABEL_HINT: 'As it will appear in the ad, e.g. “Sant Cugat”.',
        AREA_TITLE: 'Ad area',
        AREA_SUB: 'Circle where the ad is shown and areas excluded within it.',
        CENTER_LAT: 'Centre latitude',
        CENTER_LONG: 'Centre longitude',
        EXCLUSIONS: 'Exclusions',
        EXCLUSIONS_HINT: 'Circles where the ad is not shown. {{max}} at most.',
        NO_EXCLUSIONS: 'No exclusions.',
        ADD_EXCLUSION: 'Add exclusion',
        REMOVE_EXCLUSION: 'Remove exclusion',
        EXCLUSION_OUTSIDE: 'This exclusion lies outside the ad area.',
        MAP_HINT: 'Drag the centre or the edge of a circle to move it or change its radius. Click inside the area to add a 1 km exclusion.',
        MAP_MOVE: 'Drag to move',
        MAP_RESIZE: 'Drag to change the radius',
        ZOOM_IN: 'Zoom in',
        ZOOM_OUT: 'Zoom out',
        BUDGET_TITLE: 'Budget and duration',
        BUDGET_SUB: 'Total campaign budget and the days it will run.',
        DISCARD: 'Discard changes',
        NO_CHANGES: 'There are no changes to save',
        SAVED: 'Draft saved',
        SAVE_ERROR: 'The draft could not be saved.',
        SAVE_FIRST: 'Save or discard your changes before approving',

        PREVIEW_TITLE: 'Preview',
        PREVIEW_SUB: 'Texts and image with the zone name filled in. It follows the form as you type, before saving.',
        NO_TEMPLATE: 'Choose a template to see the ad.',
        SIGNUPS_TITLE: 'Attributed sign-ups',
        SIGNUPS_SUB: 'Users who came from this ad, by the role of their first routine.',
        SIGNUPS_TOTAL: 'Total',
        SIGNUPS_NO_ROUTINE: 'No routine',
        META_TITLE: 'Meta',
        META_SYNCED: 'Synced on {{date}}.',
        META_NOT_SYNCED: 'No metrics synced yet.',
        META_CAMPAIGN: 'Campaign',
        META_FACEBOOK_AD: 'Facebook ad',
        META_INSTAGRAM_AD: 'Instagram ad',
        META_FACEBOOK_STATUS: 'Facebook status',
        META_INSTAGRAM_STATUS: 'Instagram status',
        META_SPEND: 'Spent',
        META_IMPRESSIONS: 'Impressions',
        META_REACH: 'Reach',
        META_CLICKS: 'Link clicks',
        META_FEEDBACK: 'Meta review',

        APPROVE: 'Approve',
        APPROVE_TITLE: 'Approve the draft',
        APPROVE_TEXT: 'It will be ready to publish and can no longer be edited.',
        APPROVING: 'Approving…',
        APPROVED: 'Approved',
        APPROVE_INCOMPLETE: 'The draft must be completed before approval',
        APPROVE_ERROR: 'The draft could not be approved',
        REJECT: 'Reject',
        REJECT_HINT: 'Closes the draft and keeps it in the history: the zone waits for the settings period before another one.',
        DELETE: 'Delete',
        DELETE_HINT: 'Removes it for good, with its routines. Only possible if it never reached Meta.',
        DELETE_TITLE: 'Delete the draft',
        DELETE_TEXT: 'It is removed for good, with its routines. If you only want it not to be published, reject it.',
        DELETING: 'Deleting…',
        DELETED: 'Deleted',
        DELETE_ERROR: 'The draft could not be deleted',
        REJECT_TITLE: 'Reject the draft',
        REJECT_TEXT: 'It is closed and will not be published.',
        REJECT_TEXT_PUBLISHING: 'It is closed. Whatever was already created in Meta stays there: it is neither paused nor deleted.',
        REJECT_REASON: 'Reason (optional)',
        REJECTING: 'Rejecting…',
        REJECTED: 'Rejected',
        REJECT_ERROR: 'The draft could not be rejected',
        PUBLISH: 'Publish to Meta',
        PUBLISH_RETRY: 'Retry publication',
        PUBLISH_TITLE: 'Publish to Meta',
        PUBLISH_TEXT: 'A real campaign will be created with {{budget}} for {{days}} days.',
        PUBLISHING: 'Sending…',
        PUBLISH_QUEUED: 'Queued',
        PUBLISH_ERROR: 'The draft could not be published',
        META_NOT_CONFIGURED: 'Publishing to Meta is not set up yet',
        META_NOT_CONFIGURED_TEXT: 'To publish, this is missing:',
        GO_TO_SETTINGS: 'Go to settings',
      },

      TEMPLATES: {
        LIST_TITLE: 'Ad templates',
        LIST_SUB: 'Image and texts of the ads. {{placeholder}} is replaced with the zone name.',
        NEW: 'New template',
        NEW_TITLE: 'New template',
        EDIT_TITLE: 'Edit template',
        EDIT: 'Edit',
        DELETE: 'Delete',
        CREATE: 'Create template',
        NAME: 'Name',
        NAME_HINT: 'For the team only; it does not appear in the ad.',
        ROLE_HINT: 'It can only be used in drafts for the same audience.',
        HEADLINE: 'Headline',
        PRIMARY_TEXT: 'Primary text',
        PLACEHOLDER_HINT: 'Type {{placeholder}} where the zone name goes.',
        UNKNOWN_MARKERS: 'These placeholders are not replaced and will show as they are in the ad: {{markers}}. The zone one is {{placeholder}}.',
        IMAGE_URL: 'Image URL',
        IMAGE_URL_HINT: 'https address of an image that is already online: files are not uploaded.',
        IMAGE_FAILED: 'The image at that address could not be loaded.',
        ACTIVE_LABEL: 'Active (can be chosen in drafts)',
        STATE: 'Status',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        LOAD_ERROR: 'The templates could not be loaded.',
        EMPTY: 'There are no templates yet.',
        SHOWING: 'Showing {{shown}} of {{total}} templates',
        PER_PAGE: '{{count}} per page',
        PER_PAGE_LABEL: 'Templates per page',
        CREATED: 'Template created',
        UPDATED: 'Template saved',
        SAVE_ERROR: 'The template could not be saved.',
        IN_USE_ROLE: 'The audience cannot be changed: a draft uses this template.',
        DELETE_TITLE: 'Delete “{{name}}”',
        DELETE_TEXT: 'The template is removed. If you only want it not to be chosen, deactivate it.',
        DELETE_CONFIRM: 'Delete template',
        DELETING: 'Deleting…',
        DELETED: 'Deleted',
        DELETE_ERROR: 'The template could not be deleted',
        IN_USE_DELETE: 'A draft uses it. Deactivate it so it is not chosen for new drafts.',
      },
    },
  },
};
